import { TAX_TREATMENTS } from '../lib/constants'
import type { IntakeAnswers } from '../lib/types'

/** Either alone is enough: not yet seeing clients, or expecting under $20k. */
const EARLY_INCOME_BAND = 'u20'
const EARLY_CLIENT_STATUS = 'notyet'

/**
 * Lite for a practice that has not started earning yet, ahead of the ranker's
 * pick for a sole prop.
 *
 * Sent as the caller hint the offers endpoint already accepts, rather than taught
 * to the server-side ranker, because the answers behind it are the intake's and
 * the client is where they already live.
 *
 * Sole proprietors only. The other treatments file a return of their own whatever
 * they earn, and Lite excludes annual tax filing, so recommending it to them
 * would drop an obligation they still have. The API refuses an ineligible hint
 * anyway; gating here keeps it from asking and raising a warning each time.
 */
export const earlyPracticeTierHint = (
  answers: IntakeAnswers
): 'lite' | undefined => {
  if (answers.tax_treatment !== TAX_TREATMENTS.soleprop) return undefined

  const preRevenue =
    answers.expected_income_band === EARLY_INCOME_BAND ||
    answers.client_status === EARLY_CLIENT_STATUS

  return preRevenue ? 'lite' : undefined
}
